<template>
  <email-form-modal
    :modal-id="modalId"
    title="Email Work Order PDFs"
    help-text="Enter one or more emails to send the Work Orders PDFs to"
    :initial-emails="email ? [email] : null"
    :request="submitRequest"
  />
</template>

<script>
import EmailFormModal from '@/components/shared/EmailFormModal.vue';

export default {
  name: 'WorkOrdersEmailMultipleModal',
  components: {
    EmailFormModal,
  },
  props: {
    filters: Object,
    email: String,
  },
  data() {
    return {
      modalId: 'work-order-email-multiple-modal',
    };
  },
  methods: {
    submitRequest(payload) {
      return this.$workOrdersAPI.emailWorkOrderPDFs(this.filters, payload.emails);
    },
  },
};
</script>
